import { TCurrentUser } from 'types/group';
import { ERoleCode } from 'types/enumItems';

// Group provider（非 owner/PM/admin）只读看自己的 panel 状态：banner、签合同、付款、加 payer 都留给 owner。
// 对 GROUP_PROVIDER 来说 isGroupAdmin 只取决于 isAdmin，所以这里直接判断，避免引入 utils/common。
export const isReadOnlyGroupProvider = (currentUser?: TCurrentUser): boolean =>
    !!currentUser?.groupPractice && currentUser.roleCode === ERoleCode.GROUP_PROVIDER && !currentUser.isAdmin;

// 没有自己 provider 记录的 group provider 登录后 DELEGATED 到 owner 的 provider，不能看 owner 的 credentialing
export const isDelegatedGroupProvider = (currentUser?: TCurrentUser): boolean =>
    isReadOnlyGroupProvider(currentUser) && currentUser?.actingMode === 'DELEGATED';
